import { render, staticRenderFns } from "./SurveyShortcodeEntry.vue?vue&type=template&id=0bad36b8&scoped=true"
import script from "./SurveyShortcodeEntry.vue?vue&type=script&lang=js"
export * from "./SurveyShortcodeEntry.vue?vue&type=script&lang=js"
import style0 from "./SurveyShortcodeEntry.vue?vue&type=style&index=0&id=0bad36b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad36b8",
  null
  
)

export default component.exports